import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Chip,
  Box,
  Typography
} from '@mui/material';
import { ListOutlined, AddCircleOutlineOutlined } from '@mui/icons-material';
import {
  autocompleteInputSx,
  selectSx,
  labelSx,
  placeholderSx,
  statusChipSx
} from '../../styles/wizardSx';

function PicklistField({ field, value, onChange, allowCustom = true, ...props }) {
  const options = field.metadata?.options || field.options || [];

  if (allowCustom) {
    return (
      <Autocomplete
        freeSolo
        options={options}
        value={value || ''}
        onChange={(_, newValue) => onChange(newValue)}
        sx={autocompleteInputSx}
        renderInput={(params) => (
          <TextField
            {...params}
            label={field.label}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <ListOutlined sx={{ color: 'primary.main', fontSize: 18, ml: 1, mr: -0.5 }} />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <Typography variant="body2">{option}</Typography>
          </Box>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              label={option}
              size="small"
              sx={statusChipSx('info')}
              {...getTagProps({ index })}
            />
          ))
        }
        {...props}
      />
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...labelSx
      }}>
        <ListOutlined sx={{ fontSize: 16 }} />
        {field.label}
      </InputLabel>
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        label={field.label}
        sx={selectSx}
        {...props}
      >
        <MenuItem value="">
          <Typography component="span" sx={placeholderSx}>Select {field.label}</Typography>
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default PicklistField;
